import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-dijital-pazarlama-ajansi',
  meta: {
    title: 'İstanbul Dijital Pazarlama Ajansı | Thinklyze',
    description:
      'İstanbul\'un en etkili dijital pazarlama ajansı Thinklyze. SEO, Google Ads, Meta Ads, sosyal medya ve web tasarım hizmetleriyle markanızı dijitalde büyütün.',
    keywords: [
      'İstanbul dijital pazarlama ajansı',
      'İstanbul dijital reklam ajansı',
      'İstanbul performans pazarlama',
      'İstanbul SEO hizmeti',
      'İstanbul Google Ads ajansı',
      'İstanbul Meta Ads ajansı',
      'dijital pazarlama ajansı İstanbul',
      'thinklyze istanbul',
    ],
    canonical: 'https://thinklyze.com/istanbul-dijital-pazarlama-ajansi',
    image: 'https://thinklyze.com/images/logo_siyah.webp',
  },
  hero: {
    badge: 'İstanbul Dijital Pazarlama',
    title: 'İstanbul\'un Büyümesine Odaklanan Dijital Pazarlama Ajansı',
    subtitle:
      'Thinklyze olarak İstanbul\'daki işletmelerin dijital kanallardan müşteri kazanmasına, gelirlerini artırmasına ve sürdürülebilir büyüme elde etmesine yardımcı oluyoruz. Veri odaklı stratejiler, ölçülebilir sonuçlar.',
    stats: [
      { value: '200+', label: 'Başarılı Proje' },
      { value: '%340', label: 'Ortalama ROAS Artışı' },
      { value: '5.0 ★', label: 'Google Puanı' },
    ],
    highlights: [
      {
        title: 'Veri Odaklı Strateji',
        description:
          'Her kampanyayı analizlerle destekliyoruz; bütçenizi doğru kanala yönlendirir, gereksiz harcamaları ortadan kaldırırız.',
      },
      {
        title: 'Tam Entegre Hizmet',
        description:
          'SEO\'dan Google Ads\'e, Meta reklamlarından web tasarıma kadar tüm dijital kanallarınızı tek çatı altında yönetiyoruz.',
      },
      {
        title: 'Şeffaf Raporlama',
        description:
          'Haftalık ve aylık raporlarla kampanyalarınızın performansını anlık olarak takip ediyorsunuz, sürpriz yok.',
      },
    ],
  },
  problemSolution: {
    title: 'İstanbul\'daki İşletmelerin Dijitalde Karşılaştığı Sorunlar',
    subtitle:
      'Rekabetin yoğun olduğu İstanbul pazarında çoğu işletme aynı engellerle boğuşuyor. Biz bu engelleri kırmak için buradayız.',
    items: [
      {
        title: 'Reklam bütçesi boşa gidiyor',
        description:
          'Doğru hedefleme ve optimizasyon olmadan Google veya Meta reklamlarına harcanan her lira verimsiz kalır. Conversion odaklı kampanya yapısıyla bütçenizin her kuruşunu çalıştırıyoruz.',
      },
      {
        title: 'Organik trafik yok veya çok düşük',
        description:
          'SEO olmadan rakipler her arama sorgusunda önünüze geçer. İstanbul\'a özel yerel SEO ve teknik optimizasyonla sizi Google\'ın ilk sayfasına taşıyoruz.',
      },
      {
        title: 'Sosyal medya dönüşüm sağlamıyor',
        description:
          'Takipçi sayısı yüksek ama satış yok. İçerik stratejisi, UGC ve dönüşüm hunisi tasarımıyla sosyal medyanızı gelir kanalına dönüştürüyoruz.',
      },
      {
        title: 'Web sitesi ziyaretçileri müşteriye dönüşmüyor',
        description:
          'Trafik var ama satın alma yok. CRO (Dönüşüm Oranı Optimizasyonu) ve A/B testleriyle web sitenizin satış performansını katlarıyoruz.',
      },
    ],
  },
  services: {
    title: 'İstanbul İşletmeleri için Dijital Pazarlama Hizmetleri',
    subtitle:
      'İstanbul\'ın rekabetçi pazarında öne çıkmak için ihtiyacınız olan her hizmet.',
    items: [
      {
        title: 'Google Ads Yönetimi',
        description:
          'Arama, Display ve YouTube kampanyalarıyla rakiplerinizin önünde görünün. İstanbul\'daki potansiyel müşterilerinize tam doğru anda ulaşın.',
      },
      {
        title: 'Meta (Facebook & Instagram) Reklamları',
        description:
          'İstanbul\'daki hedef kitlenizi demografik, ilgi alanı ve davranış bazlı mikro-segmentasyonla yakalayan Meta reklam kampanyaları.',
      },
      {
        title: 'SEO & Yerel SEO',
        description:
          'Google\'da "İstanbul dijital pazarlama ajansı" gibi sorgularda üst sıralara çıkın. Teknik SEO, içerik ve bağlantı stratejisiyle kalıcı organik büyüme.',
      },
      {
        title: 'Sosyal Medya Yönetimi',
        description:
          'Instagram, TikTok, LinkedIn ve diğer platformlarda marka sesini oluşturun; topluluk yönetimiyle sadık müşteri kitlesi yaratın.',
      },
      {
        title: 'Web Tasarım & Geliştirme',
        description:
          'Hızlı, mobil uyumlu ve dönüşüm odaklı web siteleri. İstanbul\'daki rakiplerinizden farklılaşan kurumsal kimliğinizi dijitale taşıyoruz.',
      },
      {
        title: 'İçerik Pazarlama & UGC',
        description:
          'Markanız için özgün içerikler, video prodüksiyon ve influencer iş birlikleriyle İstanbul\'daki marka bilinirliğinizi artırın.',
      },
    ],
  },
  locationBenefits: {
    title: 'Neden İstanbul\'daki Bir Ajansla Çalışmalısınız?',
    subtitle:
      'Yerel pazar bilgisi ve global standartları birleştiriyoruz.',
    items: [
      {
        title: 'İstanbul Pazar Dinamiklerini Biliyoruz',
        description:
          'Bakırköy\'den Kadıköy\'e, Şişli\'den Ümraniye\'ye — İstanbul\'un her ilçesindeki tüketici davranışını ve rekabet ortamını iyi tanıyoruz.',
      },
      {
        title: 'Anlık İletişim & Yüz Yüze Toplantı',
        description:
          'Aynı şehirdeyiz. Stratejik kararlar için yüz yüze buluşabilir, kampanya değişikliklerini hızla hayata geçirebiliriz.',
      },
      {
        title: 'Türk Tüketicisini Anlayan Yaratıcı İçerik',
        description:
          'Yerel kültür ve dil nüanslarını bilen ekibimiz, İstanbul tüketicisine doğru seslenen içerikler üretir.',
      },
      {
        title: 'Rekabetçi Fiyat, Uluslararası Kalite',
        description:
          'İstanbul merkezli olmamız operasyonel maliyetleri düşürür; bu tasarrufu rekabetçi fiyatlarla size yansıtırız.',
      },
      {
        title: 'Çok Sektörlü Deneyim',
        description:
          'E-ticaret, perakende, sağlık, emlak, eğitim ve daha pek çok sektörde İstanbul işletmelerine başarılı sonuçlar sunduk.',
      },
      {
        title: 'Ölçülebilir KPI\'larla Çalışıyoruz',
        description:
          'Sezgisel kararlar değil; GA4, Looker Studio ve platform verileriyle her adımı ölçüyor, bütçe verimliliğini maksimize ediyoruz.',
      },
    ],
  },
  industries: {
    title: 'İstanbul\'da Hizmet Verdiğimiz Sektörler',
    subtitle:
      'Her sektörün kendine özgü dijital pazarlama ihtiyacı vardır. Deneyimli ekibimiz sektörünüze özel stratejiler geliştirir.',
    items: [
      {
        title: 'E-Ticaret & Pazaryeri',
        description:
          'Trendyol, Hepsiburada ve kendi mağaza trafiğinizi artırın; sepet terk oranını düşürün.',
      },
      {
        title: 'Perakende & Moda',
        description:
          'İstanbul\'ın moda merkezindeki markalara dönüşüm odaklı dijital kampanyalar.',
      },
      {
        title: 'Sağlık & Güzellik',
        description:
          'KVKK uyumlu dijital pazarlama ile klinik ve güzellik markalarına kaliteli hasta/müşteri kazanımı.',
      },
      {
        title: 'Emlak & İnşaat',
        description:
          'İstanbul\'daki konut ve ticari gayrimenkul projelerine nitelikli lead üretimi.',
      },
      {
        title: 'Eğitim & Kurs',
        description:
          'Online ve yüz yüze eğitim kurumlarına öğrenci kazanımı kampanyaları.',
      },
      {
        title: 'Restoran & F&B',
        description:
          'Rezervasyon ve online sipariş artışı için yerel SEO ve sosyal medya yönetimi.',
      },
    ],
  },
  process: {
    title: 'Nasıl Çalışıyoruz?',
    subtitle: 'Şeffaf ve sonuç odaklı 4 adımlık sürecimiz.',
    items: [
      {
        title: 'Keşif & Analiz',
        description:
          'İşletmenizi, rakiplerinizi ve mevcut dijital durumunuzu derinlemesine analiz ediyoruz.',
      },
      {
        title: 'Strateji & Planlama',
        description:
          'İstanbul pazarına ve hedef kitlenize özel 90 günlük büyüme planı oluşturuyoruz.',
      },
      {
        title: 'Uygulama & Optimizasyon',
        description:
          'Kampanyaları devreye alıyor, günlük verilerle optimize ediyor ve bütçe verimliliğini artırıyoruz.',
      },
      {
        title: 'Raporlama & Büyüme',
        description:
          'Haftalık/aylık raporlar ve strateji toplantılarıyla büyümeyi sürdürülebilir kılıyoruz.',
      },
    ],
  },
  faqs: [
    {
      question: 'İstanbul\'daki bir dijital pazarlama ajansıyla çalışmanın avantajı nedir?',
      answer:
        'Yerel pazar bilgisi, anlık iletişim ve Türk tüketici davranışını anlayan bir ekiple çalışmak kampanya performansını doğrudan etkiler. Thinklyze olarak İstanbul\'ın her sektöründe deneyim sahibiyiz.',
    },
    {
      question: 'Aylık minimum bütçe nedir?',
      answer:
        'Hizmet paketlerimiz işletmenizin büyüklüğüne ve hedeflerine göre değişir. Ücretsiz keşif görüşmesinde ihtiyacınıza en uygun paketi birlikte belirliyoruz.',
    },
    {
      question: 'İlk sonuçları ne zaman görürüm?',
      answer:
        'Google Ads ve Meta reklamlarında ilk 2–4 haftada ölçülebilir sonuçlar elde edilir. SEO için rekabete ve sektöre göre 3–6 aylık bir süreç beklenir.',
    },
    {
      question: 'Sözleşme süresi ne kadar?',
      answer:
        'Çoğu hizmetimizde 3 aylık başlangıç dönemi öneriyoruz; ancak kilitli uzun vadeli sözleşme zorunluluğumuz yoktur.',
    },
    {
      question: 'Raporları nasıl alacağım?',
      answer:
        'Haftalık e-posta güncellemeleri ve aylık detaylı Looker Studio dashboard raporları sunuyoruz. Dilediğinizde anlık erişim linki ile verilerinizi kendiniz de takip edebilirsiniz.',
    },
  ],
  cta: {
    badge: 'İstanbul\'da Büyüme Zamanı',
    title: 'İstanbul\'daki Rakiplerinizden Bir Adım Önce Olun',
    description:
      'Ücretsiz dijital pazarlama analizi için bugün randevu alın. Mevcut dijital durumunuzu değerlendiriyor, büyüme fırsatlarını birlikte keşfediyoruz.',
  },
  areaServed: [
    'İstanbul',
    'Bakırköy',
    'Kadıköy',
    'Şişli',
    'Beşiktaş',
    'Ümraniye',
    'Maltepe',
    'Pendik',
  ],
  coordinates: { latitude: 41.0082, longitude: 28.9784 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'Google Ads Yönetimi', href: '/services/google-ads', description: 'Arama ve Display kampanyalarıyla anında görünürlük.' },
      { name: 'SEO & GEO Optimizasyon', href: '/services/seo-geo', description: 'Organik trafik ve yerel arama sıralamalarında üst sıralar.' },
      { name: 'Meta Ads Yönetimi', href: '/services/meta-ads', description: 'Facebook ve Instagram\'da hedef kitlenize ulaşın.' },
      { name: 'Sosyal Medya Yönetimi', href: '/services/social-media', description: 'Marka bilinirliği ve topluluk oluşturma.' },
      { name: 'Web Tasarım', href: '/services/web-design', description: 'Dönüşüm odaklı modern web siteleri.' },
      { name: 'Shopify Danışmanlığı', href: '/shopify', description: 'Shopify mağazanızı büyütün.' },
    ],
  },
}

const IstanbulDigitalMarketingAgency = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulDigitalMarketingAgency
